import { AppStateType } from '../reducers'
import { IMediaType } from '../types/mediaType'
import { createSelector } from 'reselect'
import { IMediaTypes } from '../types/mediaTypes'
import { IMediaTypeGroup } from '../types/mediaTypeGroup'
import { sortArrayOfObjects } from '../services/sort'
import { selectMediaTypeGroup } from './mediaTypesGroups'

export const selectMediaType = createSelector(
  [(state: AppStateType) => state.mediaType],
  (mediaType: IMediaType) => mediaType
)

export const selectMediaTypes = createSelector(
  [(state: AppStateType) => state.mediaTypes],
  (mediaTypes: IMediaTypes) => mediaTypes && mediaTypes.list && mediaTypes
)

const createSortedMediaTypesSelector = (sortedField) =>
  createSelector(
    selectMediaTypes,
    ({ list, ...mediaTypesProps }: IMediaTypes) => ({
      ...mediaTypesProps,
      list: [...sortArrayOfObjects(list, sortedField)],
    })
  )

export const selectMediaTypesSortedByExtension = createSortedMediaTypesSelector(
  'extension'
)

export const selectMediaTypesSortedByPriority = createSortedMediaTypesSelector(
  'priority'
)

export const selectSortedMediaTypesBySelectedToGroup = createSelector(
  [selectMediaTypesSortedByExtension, selectMediaTypeGroup],
  (mediaTypes: IMediaTypes, mediaTypeGroup: IMediaTypeGroup): IMediaTypes =>
    mediaTypes &&
    mediaTypes.list &&
    mediaTypeGroup && {
      ...mediaTypes,
      list: [
        ...mediaTypes.list.filter(({ extension }) =>
          mediaTypeGroup.types.some((type) => type.extension === extension)
        ),
        ...mediaTypes.list.filter(
          ({ extension }) =>
            !mediaTypeGroup.types.some((type) => type.extension === extension)
        ),
      ],
    }
)
